import { PropsWithChildren } from "react";

import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { TextInputHelperText } from "../../../components";

type Props = PropsWithChildren<{
  label: string;
  required?: boolean;
  info?: string | React.ReactNode;
  error?: string | React.ReactNode;
  hidden?: boolean;
}>;

export default function FormField({
  label,
  required,
  info,
  error,
  hidden,
  children,
}: Props) {
  const text = required ? `${label} *` : label;
  const showHelper = required || info || error;

  if (hidden) return null;

  return (
    <View>
      <Label text={text} />
      {children}
      {showHelper && <TextInputHelperText info={info} error={error} />}
    </View>
  );
}

function Label({ text }: { text: string }) {
  const tailwind = useTailwind();
  return (
    <Text variant="labelLarge" style={tailwind("mb-2")}>
      {text}
    </Text>
  );
}
